import React, { useState, useEffect } from "react";
import { InputText } from "primereact/inputtext";
import { Calendar } from "primereact/calendar";
import { Dropdown } from "primereact/dropdown";
import { useSelector } from 'react-redux';
import { selectUser } from '../../services/store/userSlice';
import moment from "moment";
import { InputTextarea } from "primereact/inputtextarea";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { RadioButton } from "primereact/radiobutton";
import { Checkbox } from "primereact/checkbox";
import { Button } from "primereact/button";
import { trainingApi } from "../../services";
import { settingService, travelService } from "../../services/extensions";
import { AutoComplete } from "primereact/autocomplete";
import { useFormik } from "formik";
import { skillService } from "../../services/profile";
import { toast } from "react-toastify";
import { projectStatusOfResource } from '../../common/util/constants';
import { confirmDialog } from "primereact/confirmdialog";
import { Dialog } from 'primereact/dialog';
import { Editor } from 'primereact/editor';
import { Util } from '../../services';
import { Card } from "primereact/card";
import AddCourseLink from './add-course-link';


// const UpdateEmpTrfForm = ({ reload, setNewTrf, setScreen, isEdit, editTrfForm, updateClickedRow, skillFormData, userTrfDetail }) => {
const UpdateEmpTrfForm = ({ reload, userTrfDetail, type, userDetails, viewType }) => {
    const user = useSelector(selectUser);
    const loggedInUser = useSelector(selectUser);
    const [trainingCategory, setTrainingCategory] = useState([]);
    const [employeeList, setEmployeeList] = useState([]);
    const [currentProject, setCurrentProject] = useState([]);
    const [skillLevel, setSkillLevel] = useState([]);
    const [selectedSkillLevel, setSelectedSkillLevel] = useState(null);
    const [rowClick, setRowClick] = useState(true);
    const [reqTrainingPurpose, setReqTrainingPurpose] = useState([]);
    const [outComeTrainingPurpose, setOutComeTrainingPurpose] = useState([]);
    const [skillLevelStatus, setSkillLevelStatus] = useState(false);
    const [reqTrainingStatus, setReqTrainingStatus] = useState(false);
    const [outComeStatus, setOutComeStatus] = useState(false);
    const [empTrfRejectDialog, setEmpTrfRejectDialog] = useState(false);
    const [isValid, setIsValid] = useState(false);
    const [feedbackRejectedStatus, setFeedbackRejectedStatus] = useState(true);
    const [feedback, setFeedback] = useState("");
    const [peerManagerView, setPeerManagerView] = useState(false);
    const [courseLinkDialog, setCourseLinkDialog] = useState(false);
    const [courseLinks, setCourseLinks] = useState([]);
    const [allProjects, setAllProjects] = useState([]);
    const [daCurrency, setDaCurrency] = useState([]);


    useEffect(() => {
        // const empIndex = user.roles.indexOf('PM');
        // setPeerManagerView(empIndex !== 1);
        const exists = user.roles.includes('PM');
        setPeerManagerView(exists);
        const mockSkillsLevel = [
            {
                id: 1,
                skills: <b>Current skill competency level</b>,
                beginnerNoKnowledge: false,
                beginnerBasicKnowledge: false,
                intermediateGoodKnowledge: false,
                intermediateStrongExperience: false,
                expert: false,
            },
            {
                id: 2,
                skills: <b>Expected skill competency level</b>,
                beginnerNoKnowledge: false,
                beginnerBasicKnowledge: false,
                intermediateGoodKnowledge: false,
                intermediateStrongExperience: false,
                expert: false,
            },
        ];
        const curr_lvl = fetchLevelName(userTrfDetail?.currentLevel)
        const exp_lvl = fetchLevelName(userTrfDetail?.expectedLevel)
        if (curr_lvl || exp_lvl) {
            setCurrentandExpectedSkillSet(curr_lvl, exp_lvl, mockSkillsLevel)
        }
        GetAllDACurrency();
        fetchAllProjects();
        setSkillLevel(mockSkillsLevel);
        fetchCategories();
        fetchRequestedTraining();
        getUserDetails();
    }, []);

    const fetchAllProjects = () => {
        settingService.getActiveProjects().then((resp) => {
            setAllProjects(resp.data.data);
        });
    };

    const GetAllDACurrency = () => {
        travelService.GetAllDACurrency()
            .then(response => {
                if (response.data.success) {
                    const options = response.data.data.map(daCurrency => ({
                        label: `${daCurrency.title} (${daCurrency.symbol})`,
                        value: daCurrency.code
                    }));
                    setDaCurrency(options);
                }
            })
            .catch(error => {
                console.error('Error fetching DA currency:', error);
            });
    };

    const setCurrentandExpectedSkillSet = (curr_lvl, exp_lvl, productslist) => {
        productslist[0][curr_lvl] = true;
        productslist[1][exp_lvl] = true
        setSkillLevel(productslist);
    }

    const fetchLevelName = (val) => {
        var current_level;
        switch (val) {
            case 1:
                current_level = "beginnerNoKnowledge";
                break;
            case 2:
                current_level = "beginnerBasicKnowledge";
                break;
            case 3:
                current_level = "intermediateGoodKnowledge";
                break;
            case 4:
                current_level = "intermediateStrongExperience";
                break;
            case 5:
                current_level = "expert";
                break;
            default:
                current_level = "";
        }
        return current_level;
    }


    const getUserDetails = () => {
        trainingApi.getUserDetailsById(userTrfDetail?.userId).then((resp) => {
            const userData = [resp?.data?.data];
            const transformedData = userData.map((user) => {
                return {
                    ...user,
                    name: `${user.firstName} ${user.lastName}`.trim(),
                }
            });
            formik.setFieldValue("nominatedParticipant", transformedData[0]);
            const result = userData[0].Allocations.map(item => ({ isBillable: item.isBillable, billableTitle: item.isBillable ? 'Billable' : 'Non-Billable', title: item.Project.title }));
            setCurrentProject(result);
            if (userData[0].Allocations?.length > 0) {
                const firstBillableItem = userData[0].Allocations.find(item => item.isBillable === true);
                if (firstBillableItem) {
                    const filteredBillableStatus = result.filter(item => item.isBillable === true);
                    formik.setFieldValue("resourceCurrentProject", firstBillableItem?.Project?.title);
                    formik.setFieldValue("resourceProjectStatus", filteredBillableStatus[0]?.billableTitle);
                } else {
                    formik.setFieldValue("resourceCurrentProject", result[0]?.title);
                    formik.setFieldValue("resourceProjectStatus", result[0]?.billableTitle);
                }
            } else {
                setCurrentProject([]);
            }
            setEmployeeList(transformedData);
        });
    }

    const fetchRequestedTraining = () => {
        let purposeReqTrainingData;
        let businessOutcomeTrainingData;
        trainingApi.getRequestedTraining().then((resp) => {
            purposeReqTrainingData = resp?.data?.data?.filter(item => item.type === 0);
            businessOutcomeTrainingData = resp?.data?.data?.filter(item => item.type === 1);

            const updatedReqTrainingPurpose = purposeReqTrainingData.map(item => {
                const match = userTrfDetail?.purposeOfRequestedTraining.find(a => a.id === item.id);
                if (match) {
                    item.isChecked = true;
                }
                return item;
            });
            // purposeReqTrainingData = updatedReqTrainingPurpose;
            const updatedOutcomeTrainingPurpose = businessOutcomeTrainingData.map(item => {
                const match = userTrfDetail?.businessoutcomeDetails.find(a => a.id === item.id);
                if (match) {
                    item.isChecked = true;
                }
                return item;
            });
            // businessOutcomeTrainingData = updatedOutcomeTrainingPurpose;
            const hasTrueStatus = updatedReqTrainingPurpose.some(item => item.isChecked === true);
            if (!viewType) {
                if (hasTrueStatus) {
                    setReqTrainingStatus(false);
                } else {
                    setReqTrainingStatus(true);
                }
            }

            setReqTrainingPurpose(updatedReqTrainingPurpose);

            const hasTrue = updatedOutcomeTrainingPurpose.some(item => item.isChecked === true);
            if (hasTrue) {
                setOutComeStatus(false);
            } else {
                setOutComeStatus(true);
            }
            setOutComeTrainingPurpose(updatedOutcomeTrainingPurpose);
        });
    };

    const fetchCategories = () => {
        trainingApi.fetchTrainingCategoryList().then((resp) => {
            setTrainingCategory(resp.data.data);
        });
    };

    /* Filter Skill Start */

    /* Filter Skill End */
    const formik = useFormik({
        initialValues: {
            requesterName: userTrfDetail?.nameOfRequester ? userTrfDetail?.nameOfRequester : '-',
            requesterEcn: userTrfDetail?.ecnOfRequester ? userTrfDetail?.ecnOfRequester : '-',
            requesterBu: userTrfDetail?.businessUnit ? userTrfDetail?.businessUnit : '-',
            requisitionDate: new Date(),
            trainingType: userTrfDetail ? userTrfDetail?.trainingType : null,
            trainingCategory: userTrfDetail ? userTrfDetail?.categoryOfTraining : null,
            nominatedParticipant: null,
            resourceCurrentProject: null,
            resourceProjectStatus: null,
            requestedTrainingProject: userTrfDetail ? userTrfDetail?.requestedTrainingProject : null,
            trainingStartDate: userTrfDetail?.startDateOfTraining ? new Date(userTrfDetail?.startDateOfTraining) : "",
            trainingEndDate: userTrfDetail?.endDateOfTraining ? new Date(userTrfDetail?.endDateOfTraining) : "",
            trainingCurrency: userTrfDetail?.trainingCurrency ? userTrfDetail?.trainingCurrency : null,
            trainingCost: userTrfDetail?.trainingCost ? userTrfDetail?.trainingCost : "",
            courseLink: userTrfDetail?.courseLink ? userTrfDetail?.courseLink : "",
            assignedCourseHours: userTrfDetail?.assignedCourseHours ? userTrfDetail?.assignedCourseHours : "",
            assignedCourseMinutes: userTrfDetail?.assignedCourseMinutes ? userTrfDetail?.assignedCourseMinutes : "",
            improvmentAreaComment: userTrfDetail ? userTrfDetail?.improvementAreaTriggeringTrainingNeed : "",
            moduleDetails: userTrfDetail ? userTrfDetail?.moduleSpecificDetails : "",
            skillsetLevel: "",
            reqTrainingPurpose: [],
            approvalComment: "",
            trainingWithEspireId: false,
        },
        validate: (data) => {
            let errors = {};
            const isValid = skillLevel.every(item =>
                Object.values(item).some(value => value === true)
            );
            if (!isValid) {
                setSkillLevelStatus(true);
            }
            let requestedTrainingList = reqTrainingPurpose.filter(item => item.isChecked).map(item => item.id);
            let outComeTrainingList = outComeTrainingPurpose.filter(item => item.isChecked).map(item => item.id);
            if (!viewType) {
                if (requestedTrainingList.length === 0) {
                    setReqTrainingStatus(true);
                }
                if (outComeTrainingList.length === 0) {
                    setOutComeStatus(true);
                }
            }
            if (!data.trainingType) errors.trainingType = "Type is required";
            if (!data.trainingCategory) errors.trainingCategory = "Category is required";
            if (!data.trainingStartDate) errors.trainingStartDate = 'Start Date is required.';
            if (!data.trainingEndDate) errors.trainingEndDate = 'End Date is required.';
            // if (!data.trainingCost && peerManagerView) errors.trainingCost = 'Training Cost is required.';
            if (!data.improvmentAreaComment) errors.improvmentAreaComment = 'Triggering Area is required.';
            if (!data.moduleDetails) errors.moduleDetails = 'Details is required.';
            if (!data.requestedTrainingProject) errors.requestedTrainingProject = 'Project is required.';
            if (viewType) {
                if (!data.approvalComment) errors.approvalComment = 'Comment is required.';
            }
            if (data.assignedCourseMinutes && (parseInt(data.assignedCourseMinutes) > 59 || parseInt(data.assignedCourseMinutes) < 0)) {
                errors.assignedCourseMinutes = "Minutes cannot exceed 59";
            }

            return errors;
        },
        onSubmit: (data) => {
            let trainingIds = type === 0 ? [userTrfDetail?.id] : userDetails.map(item => item.id);
            let requestedTrainingList = reqTrainingPurpose.filter(item => item.isChecked).map(item => item.id);
            let outComeTrainingList = outComeTrainingPurpose.filter(item => item.isChecked).map(item => item.id);
            let trfPayload = {
                "requestedTrainingProject": data?.requestedTrainingProject,
                "trainingType": data?.trainingType,
                "categoryOfTraining": data?.trainingCategory,
                "startDateOfTraining": moment(data?.trainingStartDate).format("YYYY-MM-DD"),
                "endDateOfTraining": moment(data?.trainingEndDate).format("YYYY-MM-DD"),
                ...(!viewType && {
                    "purposeStartDateOfTraining": moment(data?.trainingStartDate).format("YYYY-MM-DD"),
                    "purposeEndDateOfTraining": moment(data?.trainingEndDate).format("YYYY-MM-DD"),
                }), "trainingCurrency": data?.trainingCurrency,
                "trainingCost": data?.trainingCost ? parseFloat(data?.trainingCost) : 0,
                // "courseLink": data?.courseLink ? data?.courseLink : '',
                "courseLink": courseLinks,
                "assignedCourseHours": data?.assignedCourseHours ? data?.assignedCourseHours : '0',
                "assignedCourseMinutes": data?.assignedCourseMinutes ? data?.assignedCourseMinutes : '0',
                "improvementAreaTriggeringTrainingNeed": data?.improvmentAreaComment,
                "moduleSpecificDetails": data?.moduleDetails,
                "currentLevel": fetchValue(0),
                "expectedLevel": fetchValue(1),
                "currentLevelValue": fetchLevelValue(0),
                "expectedLevelValue": fetchLevelValue(1),
                "purposeOfRequestedTraining": requestedTrainingList,
                "purposeOfRequestedTrainingDetails": reqTrainingPurpose.filter(item => item.isChecked).map(item => item.title).join(','),
                "businessoutcome": outComeTrainingList,
                "businessOutcomeDetails": outComeTrainingPurpose.filter(item => item.isChecked).map(item => item.title).join(','),
                // "status": peerManagerView ? 5 : 2,
                "comments": data?.approvalComment,
                "status": 2,
                "ids": trainingIds,
                "trainingWithEspireId": data?.trainingWithEspireId,
                // "id": userTrfDetail?.id,
            }
            if (!skillLevelStatus && !reqTrainingStatus && !outComeStatus) {
                UpdateUserTrfFormm(trfPayload);
                // if (peerManagerView) {
                //     UpdateRoApprovedUserTrfFormm(trfPayload);
                // } else {
                //     UpdateUserTrfFormm(trfPayload);
                // }
            }

        },
    });

    const isFormFieldValid = (name) => !!(formik.touched[name] && formik.errors[name]);
    const getFormErrorMessage = (name) => {
        return (
            isFormFieldValid(name) && (
                <small className="p-error">{formik.errors[name]}</small>
            )
        );
    };

    const UpdateUserTrfFormm = (params) => {
        confirmDialog({
            message: `Are you sure you want to approve this record?`,
            header: 'Action Confirmation',
            icon: 'pi pi-info-circle',
            acceptClassName: "p-button-danger",
            acceptLabel: 'No',
            rejectLabel: 'Yes',
            reject: () => {
                try {
                    trainingApi.updateTRFform(params).then(
                        (resp) => {
                            // console.log(resp?.data?.results[0]?.message, "<<>>>", resp)
                            toast.success(resp?.data?.results[0]?.message);
                            reload();
                        },
                        (err) => {
                            toast.error(err.response.data.error);
                        }
                    );
                } catch (error) {
                    toast.error("Unable to approved");
                }
            },
            accept: () => { }
        });
    }

    // const UpdateRoApprovedUserTrfFormm = (params) => {
    //     confirmDialog({
    //         message: `Are you sure you want to approve this record?`,
    //         header: 'Action Confirmation',
    //         icon: 'pi pi-info-circle',
    //         acceptClassName: "p-button-danger",
    //         acceptLabel: 'No',
    //         rejectLabel: 'Yes',
    //         reject: () => {
    //             try {
    //                 trainingApi.updateTRFform(params).then(
    //                     (resp) => {
    //                         toast.success(resp?.data?.message);
    //                         reload();
    //                     },
    //                     (err) => {
    //                         toast.error(err.response.data.error);
    //                     }
    //                 );
    //             } catch (error) {
    //                 toast.error("Unable to delete");
    //             }
    //         },
    //         accept: () => { }
    //     });
    // }

    const fetchLevelValue = (index) => {
        const getKeyByValue = (obj, value) => {
            return Object.keys(obj).find(key => obj[key] === value);
        };
        const keyWithTrueValue = getKeyByValue(skillLevel[index], true);
        return fetchLevelValName(keyWithTrueValue);
    };

    const fetchValue = (index) => {
        const getKeyByValue = (obj, value) => {
            return Object.keys(obj).find(key => obj[key] === value);
        };
        const keyWithTrueValue = getKeyByValue(skillLevel[index], true);
        return fetchLevelNumber(keyWithTrueValue);
    };

    const fetchLevelNumber = (levelName) => {
        const levelMapping = {
            "beginnerNoKnowledge": 1,
            "beginnerBasicKnowledge": 2,
            "intermediateGoodKnowledge": 3,
            "intermediateStrongExperience": 4,
            "expert": 5
        };
        return levelMapping[levelName] || null;
    };

    const fetchLevelValName = (levelName) => {
        const levelMapping = {
            "beginnerNoKnowledge": 'Beginner Level',
            "beginnerBasicKnowledge": 'Basic Level',
            "intermediateGoodKnowledge": 'Intermediate Level',
            "intermediateStrongExperience": 'Strong Level',
            "expert": 'Expert Level'
        };
        return levelMapping[levelName] || null;
    };

    // const handleDateChange = (date) => {
    //     formik.setFieldValue("requisitionDate", date);
    //     formik.setFieldValue("trainingEndDate", "");
    // };

    const handleTrainingStartDateChange = (date) => {
        formik.setFieldValue("trainingStartDate", date);
        formik.setFieldValue("trainingEndDate", "");
    }

    const handleTrainingEndDateChange = (date) => {
        formik.setFieldValue("trainingEndDate", date);
    }

    /* Skill Level Template Start */
    const radioTemplate = (skillLevelRadio) => (rowData) => {
        const skillLevels = ['beginnerNoKnowledge', 'beginnerBasicKnowledge', 'intermediateGoodKnowledge', 'intermediateStrongExperience', 'expert'];
        const currentSkillIndex = skillLevels.findIndex(level => skillLevel[0][level] === true);
        const currentRadioIndex = skillLevels.indexOf(skillLevelRadio);
        const isCurrentRow = rowData.id === 1;
        const isExpectedRow = rowData.id === 2;
        const isDisabled = (isCurrentRow && skillLevelRadio === 'expert') || (isExpectedRow && currentSkillIndex !== -1 && currentRadioIndex <= currentSkillIndex) || (viewType ? true : false);

        return (
            <RadioButton
                inputId={`${rowData.id}-${skillLevelRadio}`}
                checked={rowData[skillLevelRadio]}
                onChange={() => handleRadioSelection(rowData.id, skillLevelRadio)}
                disabled={isDisabled}
            />
        );
    };

    const handleRadioSelection = (productId, skillLevelRadio) => {
        const skillLevels = ['beginnerNoKnowledge', 'beginnerBasicKnowledge', 'intermediateGoodKnowledge', 'intermediateStrongExperience', 'expert'];
        const selectedLevelIndex = skillLevels.indexOf(skillLevelRadio);

        const updatedProducts = skillLevel.map((product) => {
            if (product.id === productId) {
                return {
                    ...product,
                    beginnerNoKnowledge: skillLevelRadio === "beginnerNoKnowledge",
                    beginnerBasicKnowledge: skillLevelRadio === "beginnerBasicKnowledge",
                    intermediateGoodKnowledge: skillLevelRadio === "intermediateGoodKnowledge",
                    intermediateStrongExperience: skillLevelRadio === "intermediateStrongExperience",
                    expert: skillLevelRadio === "expert",
                };
            }
            // Reset Expected level if Current level is changed to higher than or equal to Expected
            if (productId === 1 && product.id === 2) {
                const expectedLevelIndex = skillLevels.findIndex(level => product[level] === true);
                if (expectedLevelIndex !== -1 && expectedLevelIndex <= selectedLevelIndex) {
                    return {
                        ...product,
                        beginnerNoKnowledge: false,
                        beginnerBasicKnowledge: false,
                        intermediateGoodKnowledge: false,
                        intermediateStrongExperience: false,
                        expert: false,
                    };
                }
            }
            return product;
        });

        const isValid = updatedProducts.every(item =>
            Object.values(item).some(value => value === true)
        );
        if (isValid) {
            setSkillLevelStatus(false);
        }
        setSkillLevel(updatedProducts);
    };
    /* Skill Level Template Start */

    const handleCheckboxChangeforPurpose = (e, item) => {
        const isStrategicEmployeeAspiration = item.title === "Strategic - Employee Aspiration";
        const hasStrategicSelected = reqTrainingPurpose.some(i => i.title === "Strategic - Employee Aspiration" && i.isChecked);

        if (isStrategicEmployeeAspiration) {
            // When Strategic - Employee Aspiration is selected, deselect all others
            const updatedData = reqTrainingPurpose.map(i =>
                i.title === "Strategic - Employee Aspiration" ? { ...i, isChecked: e.checked } : { ...i, isChecked: false }
            );
            if (!viewType) {
                const hasTrue = updatedData.some(item => item.isChecked === true);
                setReqTrainingStatus(!hasTrue);
            }

            setReqTrainingPurpose(updatedData);
        } else if (hasStrategicSelected) {
            // Allow multiple selections when Strategic - Employee Aspiration is already selected
            const updatedData = reqTrainingPurpose.map(i =>
                i.id === item.id ? { ...i, isChecked: e.checked } : i
            );
            if (!viewType) {
                const hasTrue = updatedData.some(item => item.isChecked === true);
                setReqTrainingStatus(!hasTrue);
            }
            setReqTrainingPurpose(updatedData);
        } else {
            // Single selection for other options
            const updatedData = reqTrainingPurpose.map(i =>
                i.id === item.id ? { ...i, isChecked: true } : { ...i, isChecked: false }
            );
            setReqTrainingStatus(false);
            if (!viewType) {
                setReqTrainingPurpose(updatedData);
            }
        }
    };

    const handleCheckboxChangeforBussiness = (e, item) => {
        const updatedData = outComeTrainingPurpose.map(i =>
            i.id === item.id ? { ...i, isChecked: true } : { ...i, isChecked: false }
        );
        setOutComeStatus(false);
        setOutComeTrainingPurpose(updatedData);
    };

    const trainingType = [
        { name: "Self-Paced", value: "Self-Paced" },
        { name: "Instructor-Led", value: "Instructor-Led" },
    ];

    const renderHeader = () => {
        return (
            <span className="ql-formats">
                <button className="ql-bold" aria-label="Bold"></button>
                <button className="ql-italic" aria-label="Italic"></button>
                <button className="ql-underline" aria-label="Underline"></button>
            </span>
        );
    }

    const stripHtml = (html) => {
        const doc = new DOMParser().parseFromString(html, 'text/html');
        return doc.body.textContent || "";
    };

    const isCommentCheck = (val, type) => {
        if (val) {
            setFeedbackRejectedStatus(true);
            setIsValid(true);
        } else {
            setFeedbackRejectedStatus(false);
            setIsValid(false);
        }
    }

    const empTrfRejectionDialog = () => {
        return (<>
            <Dialog header="TRF Rejection" visible={empTrfRejectDialog} style={{ width: '700px' }} onHide={() => { setEmpTrfRejectDialog(false); }}>
                <div>
                    <div className="flex flex-wrap p-field font-bold block">
                        <div className="col-12">
                            <label htmlFor="feedback" className="font-bold block mb-2 training-heading mt-2" >Rejection Note :</label>
                            <Editor headerTemplate={renderHeader} style={{ height: '200px' }} placeholder="Rejection Note" value={feedback} onTextChange={(e) => {
                                const plainText = stripHtml(e.htmlValue);
                                setFeedback(plainText);
                                isCommentCheck(plainText);
                            }} />
                        </div>
                        {!feedbackRejectedStatus && (<span style={{ color: 'red' }}>Rejection Note is Required!</span>)}
                    </div>
                </div>

                <hr />
                <div className='' style={{ textAlign: 'right' }}>
                    <Button label='Reject' icon='pi pi-check' severity='primary' className='mr-1' onClick={() => handleSubmit("Rejection")} />
                    <Button label='Cancel' icon='pi pi-times' severity='secondary' onClick={() => { setEmpTrfRejectDialog(false); setIsValid(false); setFeedback(''); }} />
                </div>
            </Dialog>
        </>)
    }


    const handleSubmit = (status) => {
        if (status === "Rejection" && feedback == '') {
            setFeedbackRejectedStatus(false);
            setIsValid(false);
        } else {
            setFeedbackRejectedStatus(true);
            setIsValid(true);
        }
        var dataObj = [
            {
                status: !peerManagerView ? 6 : 3,
                training: userTrfDetail?.id,
                rejectComment: feedback,
            },
        ];
        try {
            if (isValid) {
                trainingApi.updateApproveRejectTrainingForm(dataObj).then(
                    (resp) => {
                        toast.success(resp?.data?.message);
                        setEmpTrfRejectDialog(false);
                        setTimeout(() => {
                            reload();
                        }, 1000);
                    },
                    (err) => {
                        toast.error(err.response.data.error);
                    }
                );
            }
        } catch (error) {
            toast.error("Unable to update");
        }
    };

    const getResourceBillingStatus = (rowData) => {
        console.log(rowData, "rowDatarowData");
        return (rowData.currentStatusOfNominatedResource === 1 ? 'Billable' : 'Non-Billable'
        )
    }

    const addCourseLinkPopup = () => {
        setCourseLinkDialog(true);
    }

    const updateCourseLink = (courseUrl) => {
        setCourseLinkDialog(false);
        setCourseLinks(courseUrl);
    }

    const removeCourseLink = (index) => {
        const updatedLinks = courseLinks.filter((_, i) => i !== index);
        setCourseLinks(updatedLinks);
    }

    const addCourseLinkDialog = () => {
        return (<>
            <Dialog header="Add Course Link" className="course_popup" visible={courseLinkDialog} style={{ width: '700px' }} onHide={() => { setCourseLinkDialog(false); }}>
                <AddCourseLink updateCourseLink={(courseUrl) => updateCourseLink(courseUrl)} />
            </Dialog>
        </>)
    }

    return (
        <div className="card">
            {type === 1 && viewType && (
                <Card>
                    <DataTable value={userDetails}>
                        {/* <Column field="ecnOfRequester" header="ECN" /> */}
                        <Column field="nameOfNominatedParticipant" header="Name" />
                        <Column field="projectName" header="Project Name"></Column>
                        <Column field="currentStatusOfNominatedResource" body={getResourceBillingStatus} header="Project Status" ></Column>
                    </DataTable>
                </Card>
            )}


            <form onSubmit={formik.handleSubmit} autoComplete='off'>
                {viewType && (
                    <div className="flex flex-wrap p-field font-bold block">
                        <div className="col-4">
                            <label htmlFor="text" className="font-bold block mb-2 training-heading mt-2">Name Of Requester (RO)</label>
                            <InputText name="requesterName" placeholder="Enter Name" className="w-full" value={formik.values.requesterName} disabled />
                        </div>
                        <div className="col-4">
                            <label htmlFor="number" className="font-bold block mb-2 training-heading mt-2">ECN Of Requester</label>
                            <InputText name="requesterEcn" placeholder="Enter ECN" className="w-full" value={formik.values.requesterEcn} disabled />
                        </div>
                        <div className="col-4">
                            <label htmlFor="text" className="font-bold block mb-2 training-heading mt-2">Business Unit / Function</label>
                            <InputText name="requesterBu" placeholder="BU" className="w-full" value={formik.values.requesterBu} disabled />
                        </div>
                    </div>
                )}

                <div className="flex flex-wrap p-field font-bold block">
                    <div className="col-4">
                        <label htmlFor="text" className="font-bold block mb-2 training-heading mt-2">Training Type</label>
                        <Dropdown name="trainingType" value={formik.values.trainingType} onChange={(e) => formik.handleChange(e)} options={trainingType} optionLabel="name" optionValue="value" placeholder="Select Type" className="w-full" />
                        {getFormErrorMessage('trainingType')}
                    </div>
                    <div className="col-4">
                        <label htmlFor="text" className="font-bold block mb-2 training-heading mt-2">Category Of Training</label>
                        <Dropdown name="trainingCategory" value={formik.values.trainingCategory} onChange={(e) => formik.handleChange(e)} options={trainingCategory} optionLabel="title" optionValue="id" placeholder="Select a Category" className="w-full" disabled={viewType ? true : false} />
                        {getFormErrorMessage('trainingCategory')}
                    </div>
                    <div className="col-4">
                        <label className="mb-4 mt-2 training-heading">Target Skill</label>
                        <div className="mt-2">
                            <div className="p-fluid">
                                <AutoComplete
                                    //   value={formik.values.targetSkill}
                                    value={userTrfDetail?.targetSkills}
                                    field="title"
                                    name="targetSkill"
                                    virtualScrollerOptions={{ itemSize: 38 }}
                                    readOnly
                                />
                                {getFormErrorMessage('targetSkill')}
                            </div>
                        </div>
                    </div>
                </div>

                <div className="flex flex-wrap p-field font-bold block">
                    {type === 0 && (
                        <>
                            <div className="col-4">
                                <label htmlFor="text" className="font-bold block mb-2 training-heading mt-2">Name Of Nominated Participant</label>
                                <Dropdown value={formik.values.nominatedParticipant} options={employeeList} name="nominatedParticipant" filter optionLabel="name" placeholder="Select Employees" className="w-full" disabled={true} />
                                {getFormErrorMessage('nominatedParticipant')}
                            </div>
                            <div className="col-4">
                                <label htmlFor="skillset" className="font-bold block mb-2 training-heading mt-2">Project Details</label>
                                <Dropdown name="resourceCurrentProject" value={formik.values.resourceCurrentProject} onChange={(e) => formik.handleChange(e)} options={currentProject} optionLabel="title" optionValue="title" placeholder="Select Project" className="w-full" disabled={true} />
                                {getFormErrorMessage('resourceCurrentProject')}
                            </div>
                            <div className="col-4">
                                <label htmlFor="skillset" className="font-bold block mb-2 training-heading mt-2">Current Status Of Nominated Resource</label>
                                <Dropdown name="resourceProjectStatus" value={formik.values.resourceProjectStatus} onChange={(e) => formik.handleChange(e)} options={projectStatusOfResource} optionValue="title" optionLabel="title" placeholder="Select Status" className="w-full" disabled={true} />
                                {getFormErrorMessage('resourceProjectStatus')}
                            </div>
                        </>
                    )}

                    {/* <div className="col-4">
            <label htmlFor="text" className="font-bold block mb-2 training-heading mt-2">Current Technology</label>
            <InputText name="resourceCurrentTech" value={formik.values.resourceCurrentTech} onChange={(e) => formik.handleChange(e)} placeholder="Enter Current Technology" className="w-full" style={{ background: "#fff" }} />
            {getFormErrorMessage('resourceCurrentTech')}
          </div> */}
                    <div className="col-4">
                        <label htmlFor="text" className="font-bold block mb-2 training-heading mt-2">Training Requisition Date</label>
                        <Calendar name="requisitionDate" value={formik.values.requisitionDate} placeholder="Select Date" showIcon className="w-full requisition-date" disabled={true} />
                    </div>
                    <div className="col-4">
                        <label htmlFor="text" className="font-bold block mb-2 mt-2 training-heading">Start Date for Training</label>
                        <Calendar name="trainingStartDate" value={formik.values.trainingStartDate} onChange={(e) => handleTrainingStartDateChange(e.target.value)} minDate={new Date()} placeholder="Select Date" showIcon className="w-full requisition-date" />
                        {getFormErrorMessage('trainingStartDate')}
                    </div>
                    <div className="col-4">
                        <label htmlFor="text" className="font-bold block mb-2 mt-2 training-heading">End Date for Training</label>
                        <Calendar name="trainingEndDate" value={formik.values.trainingEndDate} onChange={(e) => handleTrainingEndDateChange(e.target.value)} minDate={formik.values.trainingStartDate ? new Date(new Date(formik.values.trainingStartDate).getTime() + 86400000) : new Date()} placeholder="Select Date" showIcon className="w-full requisition-date" />
                        {getFormErrorMessage('trainingEndDate')}
                    </div>

                    {viewType && (
                        <>
                            <div className="col-4">
                                <label htmlFor="trainingWithEspireId" className="font-bold block mb-2 training-heading mt-2">Training ID Type</label>
                                <div className="flex align-items-center">
                                    <RadioButton
                                        inputId="espireId"
                                        name="trainingWithEspireId"
                                        value={true}
                                        onChange={(e) => formik.setFieldValue('trainingWithEspireId', e.value)}
                                        checked={formik.values.trainingWithEspireId === true}
                                    />
                                    <label htmlFor="espireId" className="ml-2 mr-6">User Espire Id</label>

                                    <RadioButton
                                        inputId="personalId"
                                        name="trainingWithEspireId"
                                        value={false}
                                        onChange={(e) => formik.setFieldValue('trainingWithEspireId', e.value)}
                                        checked={formik.values.trainingWithEspireId === false}
                                    />
                                    <label htmlFor="personalId" className="ml-2">User Personal Id</label>
                                </div>
                                {/* <div className="flex align-items-center mt-2">
                                    <RadioButton 
                                        inputId="personalId" 
                                        name="trainingWithEspireId" 
                                        value={false} 
                                        onChange={(e) => formik.setFieldValue('trainingWithEspireId', e.value)} 
                                        checked={formik.values.trainingWithEspireId === false} 
                                    />
                                    <label htmlFor="personalId" className="ml-2">User Personal Id</label>
                                </div> */}
                            </div>
                            <div className="col-4"></div>
                            <div className="col-4"></div>

                            <div className="col-4">
                                <label htmlFor="trainingCost" className="font-bold block mb-2 training-heading mt-2">Training Cost</label>
                                {/* <InputText name="trainingCost" placeholder="Training Cost" className="w-full" value={formik.values.trainingCost} onChange={(e) => formik.handleChange(e)} /> */}
                                {/* {getFormErrorMessage('trainingCost')} */}
                                <div className="flex flex-wrap p-field font-bold block">
                                    <div className="col-6">
                                        <Dropdown
                                            // id="daCurrency"
                                            name="trainingCurrency"
                                            value={formik.values.trainingCurrency}
                                            options={daCurrency}
                                            onChange={(e) => formik.setFieldValue('trainingCurrency', e.value)}
                                            placeholder="Currency"
                                            className="w-100"
                                        />
                                    </div>
                                    <div className="col-6">
                                        <InputText name="trainingCost" placeholder="Training Cost" className="w-full" value={formik.values.trainingCost} onChange={(e) => formik.handleChange(e)} />
                                    </div>
                                </div>
                            </div>
                            <div className="col-4">
                                <label htmlFor="courseLink" className="font-bold block mb-2 training-heading mt-2">Course Link</label>
                                {/* <InputText name="courseLink" placeholder="Course Link" className="w-full" value={formik.values.courseLink} onChange={(e) => formik.handleChange(e)} /> */}

                                <a href="#" onClick={addCourseLinkPopup}>Add Course Link</a>
                                <div className="mt-2">
                                    {courseLinks && courseLinks.map((link, index) => (
                                        <div key={index} className="course-link-item">
                                            <span className="course-link-text">{link}</span>
                                            <i className="pi pi-times cursor-pointer text-red-500 ml-2" onClick={() => removeCourseLink(index)} title="Remove"></i>
                                        </div>
                                    ))}
                                </div>
                                {/* {getFormErrorMessage('courseLink')} */}
                            </div>
                            <div className="col-4">
                                <label htmlFor="assignedCourseHours" className="font-bold block mb-2 training-heading mt-2">Assigned Course Duration</label>
                                <div className="flex flex-wrap p-field font-bold block">
                                    <div className="col-6">
                                        <InputText name="assignedCourseHours" placeholder="Course Hours" className="w-full" value={formik.values.assignedCourseHours} onChange={(e) => formik.handleChange(e)} />
                                    </div>
                                    <div className="col-6">
                                        <InputText name="assignedCourseMinutes" placeholder="Course Minutes" className="w-full ml-2" value={formik.values.assignedCourseMinutes} onChange={(e) => formik.handleChange(e)} />
                                        {getFormErrorMessage('assignedCourseMinutes')}
                                    </div>
                                </div>


                                {/* {getFormErrorMessage('assignedCourseHours')} */}
                            </div>
                        </>
                    )}
                </div>

                <div className="flex flex-wrap p-field font-bold block">
                    <div className="col-6">
                        <label htmlFor="improvementArea" className="font-bold block mb-2 training-heading mt-2">Improvement Area Triggering Training Need</label>
                        <InputTextarea name="improvmentAreaComment" placeholder="Mention specific improvement areas within the required technology..." rows={3} className="w-full" style={{ background: "#fff" }} value={formik.values.improvmentAreaComment} onChange={(e) => formik.handleChange(e)} disabled={viewType ? true : false} />
                        {getFormErrorMessage('improvmentAreaComment')}
                    </div>
                    <div className="col-6">
                        <label htmlFor="skillset" className="font-bold block mb-2 training-heading mt-2">Module-Specific Details</label>
                        <InputTextarea name="moduleDetails" placeholder="Enter Module Details" rows={3} className="w-full" style={{ background: "#fff" }} value={formik.values.moduleDetails} onChange={(e) => formik.handleChange(e)} disabled={viewType ? true : false} />
                        {getFormErrorMessage('moduleDetails')}
                    </div>
                </div>

                <div className="flex flex-wrap p-field font-bold block">
                    <div className="col-12">
                        <label htmlFor="skillset" className="font-bold block mb-2 training-heading mt-2">Current & Expected Level Of Skillset</label>
                        <DataTable value={skillLevel} showGridlines selectionMode={rowClick ? null : "radiobutton"} selection={selectedSkillLevel} onSelectionChange={(e) => setSelectedSkillLevel(e.value)} dataKey="id" tableStyle={{ minWidth: "50rem" }}>
                            <Column field="skills" header="Skills" style={{ width: "200px" }}></Column>
                            <Column body={radioTemplate("beginnerNoKnowledge")} header="Beginner with no knowledge" style={{ width: "200px" }}></Column>
                            <Column body={radioTemplate("beginnerBasicKnowledge")} header="Beginner with basic knowledge" style={{ width: "200px" }}></Column>
                            <Column body={radioTemplate("intermediateGoodKnowledge")} header="Intermediate with good knowledge but no hands-on experience" style={{ width: "200px" }}></Column>
                            <Column body={radioTemplate("intermediateStrongExperience")} header="Intermediate with strong hands-on experience" style={{ width: "200px" }}></Column>
                            <Column body={radioTemplate("expert")} header="Expert"></Column>
                        </DataTable>
                        {skillLevelStatus && (<span style={{ color: 'red' }}>Select Current and Expected Skill Level!</span>)}
                    </div>
                </div>

                <div className="flex flex-wrap p-field font-bold block">
                    <div className="col-4">
                        <label htmlFor="skillset" className="font-bold block mb-2 training-heading mt-2">Requested Training for Project</label>
                        <Dropdown name="requestedTrainingProject" value={formik.values.requestedTrainingProject} onChange={(e) => formik.handleChange(e)} options={allProjects} optionLabel="title" optionValue="id" placeholder="Select Project" className="w-full" filter disabled={viewType ? true : false} />
                        {getFormErrorMessage('requestedTrainingProject')}
                    </div>
                </div>


                <div className="flex flex-wrap p-field font-bold block">
                    <div className="col-12">
                        <label htmlFor="trainingPurpose" className="font-bold block mb-2 mt-2 training-heading table-header">Purpose of Requested Training</label>
                        <div className="card">
                            <div className="grid">
                                {reqTrainingPurpose.map((category) => {
                                    return (
                                        <div key={category.code} className="flex align-items-center col-6">
                                            <Checkbox inputId={category.code} name="reqTrainingPurpose" value={category}
                                                checked={category.isChecked === true} onChange={(e) => handleCheckboxChangeforPurpose(e, category)} disabled={viewType ? true : false} />
                                            <label htmlFor={category.code} className="ml-2"> {category.title} </label>
                                        </div>
                                    );
                                })}
                            </div>
                            {reqTrainingStatus && (<span style={{ color: 'red' }}>Select Purpose of Requested Training!</span>)}
                        </div>
                    </div>
                </div>

                <div className="flex flex-wrap p-field font-bold block">
                    <div className="col-12">
                        <label
                            htmlFor="trainingPurpose"
                            className="font-bold block mb-2 mt-2 training-heading table-header"
                        >
                            Which of business outcome (s) mentioned below going to be
                            directly/indirectly impacted as an effectiveness of requested
                            training ?
                        </label>
                        <div className="card">
                            <div className="grid">
                                {outComeTrainingPurpose.map((category) => {
                                    return (
                                        <div key={category.code} className="col-6">
                                            <Checkbox
                                                inputId={category.code}
                                                name="outComeTrainingPurpose"
                                                value={category}
                                                checked={category.isChecked === true}
                                                onChange={(e) => handleCheckboxChangeforBussiness(e, category)}
                                                disabled={viewType ? true : false}
                                            />
                                            <label htmlFor={category.code} className="ml-2">
                                                {category.title}
                                            </label>
                                        </div>
                                    );
                                })}
                            </div>
                        </div>
                    </div>
                    {outComeStatus && (<span style={{ color: 'red' }}>Select Business Outcome (s)!</span>)}
                </div>
                {viewType && (
                    <div className="flex flex-wrap p-field font-bold block">
                        <div className="col">
                            <label htmlFor="improvementArea" className="font-bold block mb-2 training-heading mt-2">Approval Notes</label>
                            <InputTextarea name="approvalComment" placeholder="Approval Comment" rows={3} className="w-full" style={{ background: "#fff" }} value={formik.values.approvalComment} onChange={(e) => formik.handleChange(e)} />
                            {getFormErrorMessage('approvalComment')}
                        </div>
                    </div>
                )}

                {/* <div className="flex flex-wrap p-field font-bold block mt-4">
                    <div className="col-12 flex">
                        <Button type="submit" label="Update & Approve" />
                        <Button type="button" label="Reject" onClick={() => setEmpTrfRejectDialog(true)} />
                    </div>
                </div> */}



                <div className="flex flex-wrap p-field font-bold block">
                    <div className="col-4"></div>
                    <div className="col-4">
                        <Button type="submit" label="Update & Approve" />
                        <Button className="ml-4" type="button" label="Reject" onClick={() => setEmpTrfRejectDialog(true)} />
                    </div>
                    <div className="col-4"></div>
                </div>
            </form>
            {empTrfRejectionDialog()}
            {addCourseLinkDialog()}
        </div>
    )
}

export default UpdateEmpTrfForm;
